export default __webpack_public_path__ + "static/media/KolkataLineUpM.042cf356.svg";